<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div class="error" v-for="(error, index) in errors" v-bind:key="index">{{ error }}</div>
      <div>
        PITANJE:
        <input type="text" v-model="surveyQuestion.question" />
      </div>
      <div>
        Vrsta unosa:
        <select v-model="surveyQuestion.questionType">
          <option v-for="(option, index) in inputOptions" v-bind:key="index">{{ option }}</option>
        </select>
      </div>
      <div>
        ZA RADIONICE:
        <input type="checkbox" v-model="surveyQuestion.isForWorkshop" />
      </div>
      <div class="modaladmin-footer">
        <button
          type="button"
          v-bind:disabled="!surveyQuestion.question || !surveyQuestion.questionType"
          v-on:click="validateAndSave"
        >
          SPREMI
        </button>
        <button type="button" v-on:click="$emit('cancel', surveyQuestion)">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', surveyQuestion)"></a>
  </div>
</template>

<script>
export default {
  name: 'AddEditSurveyQuestionsModal',
  data() {
    return {
      errors: [],
      surveyQuestions: {},
      inputOptions: [],
    };
  },
  props: {
    surveyQuestion: {},
  },
  created() {
    this.$axios
      .get(`${this.$API_URL}/survey-questions/survey-question-type-enum`)
      .then(response => {
        this.inputOptions = response.data;
      })
      .catch(() => {
        alert('Greška u dohvaćanju vrste pitanja.');
      });
  },
  methods: {
    validateAndSave: function() {
      if (this.validate()) this.$emit('save', this.surveyQuestion);
    },
    validate: function() {
      this.errors = [];

      if (!this.surveyQuestion.question) this.errors.push('Pitanje ne može biti prazno.');

      if (this.errors.length) return false;

      return true;
    },
  },
};
</script>
